import { inject, Injectable } from '@angular/core';
import {
  BaseWebsocketMessage,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { TriggerPayload } from '@qtek/shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TriggerService {
  private readonly webSocketService = inject(WebSocketService);

  entityName: WebsocketEntTypes = 'trigger' as WebsocketEntTypes;
  triggerManager = new WSEntityManager(this.webSocketService, this.entityName);

  readonly webSocketIsAlive$ = this.webSocketService.getWebSocketIsAlive$();

  subscribe(): Observable<BaseWebsocketMessage> {
    return this.triggerManager.subscribeEntity({});
  }

  createTrigger(payload: TriggerPayload): void {
    this.triggerManager.create({ res: payload });
  }

  updateTrigger(payload: Partial<TriggerPayload>, id: string): void {
    this.triggerManager.update({ res: payload, id });
  }

  deleteTrigger(id: string, refId?: string): void {
    this.triggerManager.delete({ id, mysid: refId });
  }

  getTrigger(id: string): void {
    this.triggerManager.query({ id });
  }
}
